import $ from "jquery";

function refresh_appointment_time_fields() {
  $('.calendar-time-checkbox:checked').siblings().prop("disabled", false);
  $('.calendar-time-checkbox:checked').parent().addClass("font-weight-bold");
  $('.calendar-time-checkbox:not(:checked)').siblings().prop("disabled", true);
  $('.calendar-time-checkbox:not(:checked)').parent().removeClass("font-weight-bold");
}

$(document).on('click', '#calendar-day-check-all', function(event) {
  event.preventDefault();
  $('.calendar-time-checkbox').prop('checked', true);
  refresh_appointment_time_fields();
});

$(document).on('turbolinks:load', () => {
  refresh_appointment_time_fields();

  $('.calendar-hours-row-header').click(function() {
    const check_all = $(this).children('input[type="checkbox"]').first().is(':checked');
    $(this).parent().siblings('td').children('label').children('input[type="checkbox"]').prop('checked', check_all)
    refresh_appointment_time_fields();
  });

  $('#calendar-day-check-all').click(function(event) {
    event.preventDefault();
    $('.calendar-time-checkbox').prop('checked', true);
    refresh_appointment_time_fields();
  });

  $('#calendar-day-uncheck-all').click(function(event) {
    event.preventDefault();
    $('.calendar-time-checkbox').prop('checked', false);
    refresh_appointment_time_fields();
  });

  $('#calendar-day-check-operating-hours').click(function(event) {
    event.preventDefault();
    const open_hour = $('#calendar-day-open-operating-hour').val();
    let open_hour_date = new Date();
    const open_hour_data = open_hour.split(":");
    open_hour_date.setHours(parseInt(open_hour_data[0]),parseInt(open_hour_data[1]),parseInt(open_hour_data[2]))

    const close_hour = $('#calendar-day-close-operating-hour').val();
    let close_hour_date = new Date();
    const close_hour_data = close_hour.split(":");
    close_hour_date.setHours(parseInt(close_hour_data[0]),parseInt(close_hour_data[1]),parseInt(close_hour_data[2]))

    $('.calendar-time-checkbox').each(function() {
      const checkbox_hour = $(this).siblings('.calendar-time-checkbox-time').first().val();
      let checkbox_hour_date = new Date();
      const checkbox_hour_data = checkbox_hour.split(":");
      checkbox_hour_date.setHours(parseInt(checkbox_hour_data[0]),parseInt(checkbox_hour_data[1]),parseInt(checkbox_hour_data[2]));

      if (open_hour_date <= checkbox_hour_date && close_hour_date >= checkbox_hour_date) {
        $(this).prop('checked', true);
      }
    });

    refresh_appointment_time_fields();
  });

  $('.calendar-time-checkbox').change(() => {
    refresh_appointment_time_fields();
  });
});